export type SupportTier = 'Tier 1' | 'Tier 2' | 'Tier 3';

/**
 * Support tier of a subscription, derived from its active (billable) licenses.
 * The returned values must stay identical to the options of the `Tier` select
 * of the Notion tickets database: they are read back from the Gleap session and
 * copied onto the ticket as-is.
 */
export const getSupportTier = (
  activeLicenses: number | null | undefined,
): SupportTier | undefined => {
  if (typeof activeLicenses !== 'number') return undefined;
  if (activeLicenses >= 10) return 'Tier 1';
  if (activeLicenses >= 5) return 'Tier 2';
  return 'Tier 3';
};
